import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';

import { SideNavComponent } from '@components';
import { HeaderComponent } from '@components';
import { FeedbackDrawerComponent } from '@components';
import { GlobalChatDrawerComponent } from '@components';

@Component({
  selector: 'app-base-page',
  templateUrl: './base-page.page.html',
  styleUrls: ['./base-page.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    SideNavComponent,
    HeaderComponent,
    FeedbackDrawerComponent,
    GlobalChatDrawerComponent,
  ],
})
export class BasePage {}
